import createAppDataSliceAndThunk from "./appDataSlice";
import { messagesBg, messagesEn } from "../../../../i18n";

const getStatuses = () => {
  const statuses = [
    {
      id: "full",
      name: messagesBg.translation["l.eqfStatus.full"],
      nameEn: messagesEn.translation["l.eqfStatus.full"],
    },
    {
      id: "partial",
      name: messagesBg.translation["l.eqfStatus.partial"],
      nameEn: messagesEn.translation["l.eqfStatus.partial"],
    },
    {
      id: "none",
      name: messagesBg.translation["l.eqfStatus.none"],
      nameEn: messagesEn.translation["l.eqfStatus.none"],
    },
  ];
  return Promise.resolve(statuses);
};

const [asyncThunk, slice] = createAppDataSliceAndThunk("eqfStatuses", () => getStatuses);

export const eqfStatusesThunk = asyncThunk;

export default slice.reducer;
